import React from "react";
import { Routes, Route } from "react-router-dom";
import config from "../../config";
import { Screen } from "../../common/components";
import Uploads from "./Uploads";
import ValidationErrors from "./ValidationErrors";

export const routePrefix = `${config.paths.auth}/${config.paths.dataCheck}`;

export default () => (
    <Routes>
        <Route path={`/`} element={<Uploads />} />
        <Route path={`:uploadId`} element={<ValidationErrors />} />
        <Route
            path={`/${config.paths.dataCheck}`}
            element={
                <Screen>
                    <ValidationErrors />
                </Screen>
            }
        />
    </Routes>
);
